import axios from "axios";
import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface RegtankIndOnboardingData {
  token: string;
}

const getRegtankIndOnboardingLink = async ({
  token,
}: RegtankIndOnboardingData) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/regtank-individual-onboarding`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default getRegtankIndOnboardingLink;
